<template>
    <v-tab-item :key="'zonas'">
        <br/>
        <v-list subheader v-if="zonas && zonas.length">

            <template v-for="item in zonas">
                <v-list-tile avatar :key="item.numero">
                    <v-list-tile-avatar>
                        {{item.numero}}
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-sub-title v-html="item.setor"/>
                    </v-list-tile-content>
                </v-list-tile>
                <v-divider :key="item.numero"/>
            </template>

        </v-list>

        <v-container fluid v-if="!zonas || !zonas.length">
            <v-chip color="indigo" text-color="white" style="width: 100%" >
                <v-avatar>
                    <v-icon>camera_rear</v-icon>
                </v-avatar>
                NENHUMA ZONA
            </v-chip>
        </v-container>

    </v-tab-item>
</template>

<script>
    export default {
        name: "list-zonas",
        props: {
            zonas: {
                default: []
            }
        }
    };
</script>

<style scoped>

</style>
